import { useAlert } from '@ads/components-react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useGetApiV1ExamRevisionBotexamid } from '@/shared/api/generated';
import type { RevisionExamDetail } from '../types/revision';

/**
 * Retorna o detalhe de cabeçalho/breadcrumb de uma prova em revisão a partir de
 * `GET /api/v1/exam/revision/{botExamId}` (`ClassroomDisciplineBotExamReviewViewModel`),
 * usando o título real da prova. Faz uma chamada leve (uma questão) apenas para o
 * cabeçalho — as telas que já carregam a revisão completa usam o título de lá.
 *
 * Em caso de falha, dispara um alert de erro (`useAlert`) e mantém um título
 * neutro, sem quebrar a tela.
 *
 * @param examId - ID da prova bot em revisão
 * @returns Detalhe de exibição com o título real da prova
 */
export function useRevisionDetail(examId: number): RevisionExamDetail {
  const { alert } = useAlert();
  const { t } = useTranslation('examRevision');

  const query = useGetApiV1ExamRevisionBotexamid(
    examId,
    { pageNumber: 1, pageSize: 1 },
    { query: { enabled: examId > 0 } },
  );

  useEffect(() => {
    if (query.isError) alert({ alertType: 'warning', title: t('review.toast.loadError') });
  }, [query.isError, alert, t]);

  return {
    id: examId,
    title: query.data?.title ?? '',
    disciplineName: '',
    date: '',
  };
}
